export default "__VITE_ASSET__Cc$Z1h0u__"